export default "__VITE_ASSET__DTHlphW4__"